export default {
  SET_ERROR_OBJECT(state, payload) {
    if (typeof payload === 'object' && !Array.isArray(payload)) {
      const options = {
        message: 'Er ging iets mis. Probeer het a.u.b. nog eens.',
        type: 'error',
        showClose: true,
        duration: 5000,
        ...payload
      }
      state.errorObj = options
    } else {
      throw new TypeError()
    }
  }
}
